import classnames from 'classnames';
import * as React from 'react';
import * as IoC from 'typescript-ioc';
import { DateFnsFormats } from '../../../../../infrastructure/date-formatter';
import { DateTimeFormatter } from '../../../../../infrastructure/implementations/date-formatter';
import './list-day-item.scss';


const dateTimeFormatter = IoC.Container.get<DateTimeFormatter>(DateTimeFormatter);

const ListDayItem = (props: { date: Date; eventTimezone: string; colSpan: number; className?: string }) => {
    const { date, eventTimezone, colSpan, className } = props;

    const dayStringInEventTimezone = dateTimeFormatter.dateToFormattedString(
        date,
        DateFnsFormats.StringifiedFullDayMonthNumericDateYear,
        eventTimezone
    );

    return (
        <tr>
            <td colSpan={colSpan} className={classnames('single-row-title-cell', 'date-cell', className)}>
                <span className='table-list-layout__inline-title'>{dayStringInEventTimezone}</span>
            </td>
        </tr>
    );
};

export { ListDayItem };
